// ===========================================
// AUTH INTERCEPTOR OPTIMIZADO
// ENTERPRISE + TIMEOUT + RETRY GET
// ===========================================
import { toast } from 'react-toastify';

// ===========================================
// SESSION EXPIRED
// ===========================================
export const handleUnauthorized = () => {

  localStorage.clear();
  sessionStorage.clear();

  toast.warning('Sesión expirada por seguridad');

  setTimeout(() => {
    window.location.href = '/login';
  }, 3000);

};

// ===========================================
// DELAY HELPER
// ===========================================
const delay = (ms) =>
  new Promise(resolve => setTimeout(resolve, ms));

// ===========================================
// SECURE FETCH
// ===========================================
export const secureFetch = async (
  url,
  options = {},
  retryCount = 3
) => {

  const controller = new AbortController();

  // timeout 25 segundos
  const timeout = setTimeout(() => {
    controller.abort();
  }, 25000);

  try {

    const response = await fetch(url, {
      ...options,
      signal: controller.signal
    });

    clearTimeout(timeout);

    // =======================================
    // 401
    // =======================================
    if (response.status === 401) {

      handleUnauthorized();

      throw new Error('Session expired');

    }

    return response;

  } catch (error) {

    clearTimeout(timeout);

    // =======================================
    // SESSION EXPIRED
    // =======================================
    if (error.message === 'Session expired') {
      throw error;
    }

    // =======================================
    // RETRY SOLO GET
    // =======================================
    const method = (
      options.method || 'GET'
    ).toUpperCase();

    const shouldRetry =
      method === 'GET' &&
      retryCount > 0 &&
      error.name !== 'AbortError'; // ← no reintentar si fue timeout

    if (shouldRetry) {

      console.warn(
        `🔄 Retry request: ${url}`
      );

      await delay(1000);

      return secureFetch(
        url,
        options,
        retryCount - 1
      );
    }

    // =======================================
    // TIMEOUT
    // =======================================
    if (error.name === 'AbortError') {

      console.error(
        `⏱ Timeout request: ${url}`
      );

      throw new Error(
        'Timeout de conexión con el servidor'
      );

    }

    throw error;
  }
};

// ===========================================
// AUTH HEADERS
// ===========================================
export const getAuthHeaders = () => {

  const token = sessionStorage.getItem(
    'mapasac_access_token'
  );

  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };

};

// ===========================================
// AUTH FETCH
// ===========================================
export const authFetch = async (
  url,
  options = {}
) => {

  const headers = {
    ...getAuthHeaders(),
    ...options.headers
  };

  return secureFetch(url, {
    ...options,
    headers
  });

};